
import { SELECT_INPUT_TYPE } from "@mavichpe/dynamic-forms";

const BarcodeFormFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "barcodeFormat",
                        "label": "Tipo de Formato",
                        "options": {
                            "3": "2x50 (100 etiquetas) con Impresora"
                        },
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                    },
                ],
            ]
        }
    ],
};


export default BarcodeFormFormConfig;